import { Box, Button, Chip, Stack, Typography, ValidationErrors, newToast, openFile } from "@compass/core";
import { SubmitButton } from "components";
import { Export, ExportGridData, ExportPreviewInfo } from "generated/openApi";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";
import PreviewIcon from '@mui/icons-material/Preview';

export const ExportPageHeader = (props: {
  handle: string;
  _export: Export | undefined;
  setGridData: React.Dispatch<React.SetStateAction<ExportGridData | undefined>>;
  screen: "config" | "grid";
  setScreen: React.Dispatch<React.SetStateAction<"config" | "grid">>;
  setValidationErrors: (errors: ValidationErrors) => void;
}) => {
  const dispatch = useDispatch();

  const [previewInfo, setPreviewInfo] = useState<ExportPreviewInfo>();
  const [canGetPreviewInfo, setCanGetPreviewInfo] = useState<boolean>(true);

  useEffect(() => {
    if (props._export?.exportTypeId) {
      setCanGetPreviewInfo(true);
    }
  }, [props._export]);

  const getPreviewInfo = (_export: Export | undefined) => {
    ApiService.exports.getExportPreview(_export!).then((response) => {
      setPreviewInfo(response);
    });
  };

  // const generateExport = (_export: Export | undefined) => {
  //   props.setValidationErrors({});

  //   ApiService.exports
  //     .generateExport(_export!)
  //     .then((response) => {
  //       openFile(response.fileName, response.base64String, response.contentType);
  //     })
  //     .catch((ex) => {
  //       dispatch(setAppToast(newToast("error")));
  //       props.setValidationErrors(ex.response);
  //     });
  // };

  const generateGridData = (_export: Export | undefined) => {
    props.setValidationErrors({});

    ApiService.exports
      .generateGridData(_export!)
      .then((response) => {
        props.setGridData(response);
        props.setScreen("grid");
      })
      .catch((ex) => {
        dispatch(setAppToast(newToast("error")));
        props.setValidationErrors(ex.response);
      });
  };

  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="inherit">{props.handle}</Typography>

      <Stack direction="row" alignItems="center" spacing="sm">
        {props.screen === "config" && (
          <>
            {canGetPreviewInfo ? (
              <PreviewIcon
              color="primary"
              fontSize="large"
                onClick={() => {
                  getPreviewInfo(props._export);
                  setCanGetPreviewInfo(false);
                }}
              >

              </PreviewIcon>
            ) : (
              <Chip
                label={
                  <Stack direction="row" alignItems={"center"} spacing="xs">
                    <Box fontWeight="medium">{previewInfo?.exportRowCount}</Box>
                    <Box>rows</Box>
                    {previewInfo?.excelSheetCount !== undefined && previewInfo?.excelSheetCount > 1 && (
                      <Box>will be exported into {previewInfo?.excelSheetCount} sheets</Box>
                    )}
                  </Stack>
                }
              />
            )}

            <SubmitButton label="Generate" onClick={() => generateGridData(props._export)} />
          </>
        )}
        {props.screen === "grid" && (
          <Button onClick={() => props.setScreen("config")} variant="outlined">
            Back
          </Button>
        )}
      </Stack>
    </Stack>
  );
};
